

import React from "react";
import { Modal, Box } from "@mui/material";
import ClaimInstructionsPage from "../claimMgmt/instructions/claimInstructions";

export const InstructionsModal = ({ instructionsModalOpen, setInstructionsModalOpen }) => {
  
  // Function to handle Agree and close the modal
  const handleInstructionsAgree = () => {
    // You can add any logic here for when the user agrees
    setInstructionsModalOpen(false); // Close the modal
  };

  return (
    <Modal
      open={instructionsModalOpen}
      onClose={() => setInstructionsModalOpen(false)}
      aria-labelledby="instructions-modal-title"
      aria-describedby="instructions-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          maxWidth: 1000,
          width: "90%",
          maxHeight: "80vh",
          overflowY: "auto",
          borderRadius: 2,
        }}
      >
        <ClaimInstructionsPage onAgree={handleInstructionsAgree} />
      </Box>
    </Modal>
  );
};
